/**
 * Act1Screen — 第一幕主屏幕
 *
 * 组合 TopBar + ChatArea + BottomPanel
 */
import React, { useEffect, useRef } from 'react';
import { Act1TopBar } from './Act1TopBar';
import { Act1ChatArea } from './Act1ChatArea';
import { Act1BottomPanel } from './Act1BottomPanel';
import { useAct1Store } from '../../stores/act1Store';
import { useRootStore } from '../../stores/rootStore';
import { useAct1Loop } from '../../hooks/useAct1Loop';
import type { Act1Card } from '@shared/types/cards';

interface Act1ScreenProps {
  onSettingsClick?: () => void;
}

export const Act1Screen: React.FC<Act1ScreenProps> = ({ onSettingsClick }) => {
  const root = useRootStore();
  const act1 = useAct1Store();
  const { playCard, skip, startFirstRound, phase } = useAct1Loop();
  const hasStarted = useRef(false);

  // Auto-start first round
  useEffect(() => {
    if (!hasStarted.current && act1.phase === 'WAITING' && act1.messages.length === 0) {
      hasStarted.current = true;
      startFirstRound();
    }
  }, [act1.phase, act1.messages.length, startFirstRound]);

  if (!root.protagonistA || !root.protagonistB) return null;

  const handlePlayCard = (card: Act1Card, targetId: string) => {
    playCard(card, targetId);
  };

  return (
    <div className="h-screen flex flex-col bg-cream">
      <Act1TopBar
        round={act1.round}
        familyA={root.familyA}
        familyB={root.familyB}
        familyAttitudes={act1.familyAttitudes}
        onSettingsClick={onSettingsClick}
      />

      <Act1ChatArea
        messages={act1.messages}
        protagonistA={root.protagonistA}
        protagonistB={root.protagonistB}
        familyA={root.familyA}
        familyB={root.familyB}
        isTyping={act1.isTyping}
        typingSpeaker={act1.typingSpeaker}
        streamingText={act1.streamingText}
        streamingAgentName={act1.streamingAgentName}
        streamingAgentRole={act1.streamingAgentRole}
        currentSpeaker={act1.currentSpeaker}
        isCardNarrating={act1.isCardNarrating}
        cardNarrativeText={act1.cardNarrativeText}
      />

      <Act1BottomPanel
        hand={act1.hand}
        deckSize={act1.deck.length}
        phase={phase}
        protagonistA={root.protagonistA}
        protagonistB={root.protagonistB}
        familyA={root.familyA}
        familyB={root.familyB}
        onPlayCard={handlePlayCard}
        onSkip={skip}
      />
    </div>
  );
};

export default Act1Screen;
